import type { ProgressReporter } from './types';

export function createProgressReporter(
  totalWeight: number,
  onChange: (fraction: number, label: string) => void,
  yieldToUi: () => Promise<void>
): ProgressReporter {
  let completedWeight = 0;

  return {
    async run<T>(label: string, weight: number, work: () => T): Promise<T> {
      onChange(completedWeight / totalWeight, label);
      await yieldToUi();
      const result = await work();
      completedWeight += weight;
      return result;
    },

    get fraction(): number {
      return completedWeight / totalWeight;
    },
  };
}
